(() => {
  const button = document.querySelector('[data-product-back]');
  if (!button) return;
  let saved;
  try {
    saved = JSON.parse(sessionStorage.getItem('bn-product-search-return'));
    sessionStorage.removeItem('bn-product-search-return');
  } catch (error) {}
  let referrer;
  try { referrer = new URL(document.referrer); } catch (error) {}
  let destination;
  if (saved && saved.target === location.pathname && Date.now() - saved.time < 300000) {
    try {
      const url = new URL(saved.back);
      if (url.origin === location.origin && /\/search\/?$/.test(url.pathname)) destination = url;
    } catch (error) {}
  }
  if (!destination && referrer && referrer.origin === location.origin && !/\/(products|cart|checkouts|account)(\/|$)/.test(referrer.pathname)) {
    destination = referrer;
  }
  if (!destination) return;
  button.href = destination.href;
  if (/\/search\/?$/.test(destination.pathname)) button.querySelector('span').textContent = button.dataset.resultsLabel;
  button.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (referrer && referrer.href === destination.href && history.length > 1) {
      event.preventDefault();
      history.back();
    }
  });
})();
